import Header from '../components/Header';
import Footer from '../components/footer';
import Cont from '../components/contact'

function Contact(props) {
  return (
        (<>
          <Header />
          <div className='container text-center'  style={{ paddingTop: 30, paddingBottom: 30}}>
            <h1 className='section-title' style={{marginBottom: 30}}>
              تواصل معنا
            </h1>
            <div style={{background: 'white', borderRadius: 12, padding: 40, boxShadow: '0 2px 8px rgba(0,0,0,0.08)'}}>
              <Cont/>
            </div>
          </div>

          <Footer />
        </>)
        
  );
}

export default Contact;